import React from "react"

import ImageGallery from "react-image-gallery"

import galleryImage01 from "../../../images/Outdoor_Cameras/IN-5907_HD/5905v5907.webp"
import galleryImage01Thumb from "../../../images/Outdoor_Cameras/IN-5907_HD/5905v5907_thumb.webp"
import galleryImage02 from "../../../images/Outdoor_Cameras/IN-5907_HD/5905v5907_2.webp"
import galleryImage02Thumb from "../../../images/Outdoor_Cameras/IN-5907_HD/5905v5907_2_thumb.webp"
import galleryImage03 from "../../../images/Outdoor_Cameras/IN-5907_HD/5905v5907_3.webp"
import galleryImage03Thumb from "../../../images/Outdoor_Cameras/IN-5907_HD/5905v5907_3_thumb.webp"

require("react-image-gallery/styles/css/image-gallery.css")

export class IN9008ImageQGallery extends React.Component {
  render() {
    const images = [{ original: galleryImage01, thumbnail: galleryImage01Thumb }, { original: galleryImage02, thumbnail: galleryImage02Thumb }, { original: galleryImage03, thumbnail: galleryImage03Thumb }];

    return (
      <div style={{ padding: '15px',maxWidth: '1115px', margin: '2.5rem 0 2.5rem 0', boxShadow: '0 2px 3px 0 rgb(0 0 0 / 36%' }}>
        <ImageGallery items={images} lazyLoad={true} showPlayButton={false} />
      </div>
    );
  }
}

export default IN9008ImageQGallery
